import { createActions } from 'redux-actions'

export const { clearRedux } = createActions({
  CLEAR_REDUX: path => ({ path })
})
